/**
 * Modal configuration presets for CommunicationMessageModal
 */
const DEFAULT_LABELS = {
  individualModeLabel: 'Message individual(s)',
  groupModeLabel: 'Message group/subgroup/cohort',
  individualPlaceholder: "Child's Name",
  groupPlaceholder: 'Start typing',
  pcPlaceholder: 'Start typing to search for Tips',
  modalTitle: 'New Message',
  previewTitle: 'Message preview'
};

export const MODAL_CONFIGS = {
  DEFAULT: {
    allowModeSwitch: true,
    allowTranslation: true,
    allowContentSelection: true,
    forcePreview: false,
    showAgeRanges: true,
    defaultMode: 'individual',
    showCardSelector: true,
    showTipSelector: true,
    labels: DEFAULT_LABELS
  },
  LIBRARY_SEND_CARD: {
    allowModeSwitch: true,
    allowTranslation: true,
    allowContentSelection: false, // Content already pre-selected
    forcePreview: false,
    showAgeRanges: true,
    defaultMode: 'individual',
    showCardSelector: true,
    showTipSelector: false,
    labels: DEFAULT_LABELS
  },
  LIBRARY_SEND_TIP: {
    allowModeSwitch: true,
    allowTranslation: true,
    allowContentSelection: false, // Content already pre-selected
    forcePreview: false,
    showAgeRanges: true,
    defaultMode: 'individual',
    showCardSelector: false,
    showTipSelector: true,
    labels: DEFAULT_LABELS
  },
  TRANSLATE_ONLY: {
    allowModeSwitch: false,
    allowTranslation: true,
    allowContentSelection: true,
    forcePreview: true,
    showAgeRanges: false,
    defaultMode: 'individual',
    showCardSelector: true,
    showTipSelector: true,
    labels: DEFAULT_LABELS
  }
};

/**
 * Creates a modal configuration by merging a preset with custom overrides
 * @param {string} preset - Preset name ('DEFAULT', 'LIBRARY_SEND_CARD', 'LIBRARY_SEND_TIP', 'TRANSLATE_ONLY')
 * @param {Object} overrides - Custom configuration to override preset values
 * @returns {Object} - Merged configuration object
 */
export const createModalConfig = (preset = 'DEFAULT', overrides = {}) => {
  const baseConfig = MODAL_CONFIGS[preset] || MODAL_CONFIGS.DEFAULT;

  return {
    ...baseConfig,
    ...overrides,
    labels: { ...baseConfig.labels, ...(overrides.labels || {}) }
  };
};
